'use client';
import { createContext, useContext, useEffect, useState } from 'react';
import { TAnwser, TAppStore, TRecommendation, TStore, TLocaleData } from '@/shared/types';
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { styleName } from '@/config/const';
type TCmsStore = {
  storeConfig: TStore
  localeData: TLocaleData
  locale: string
}
const StoreContext = createContext<TCmsStore | null>(null);
export const StoreProvider = StoreContext.Provider;
export function useCmsStore() {
  const context = useContext(StoreContext);
  return context;
}
const initialState = {
  answer: {
    atmosphere: '',
    atmosphereName: '',
    recipes: [],
  },
  results: undefined,
  secondResults: undefined,
  isReady: false,
  alcohol: undefined,
}
export const useAppStore = create<TAppStore>()(
  persist((set) => ({
    ...initialState,
    setAnswer: (answer: TAnwser) => set({ answer, isReady: true }),
    resetAnswer: () => set({ ...initialState, isReady: false }),
    setResults: (results: TRecommendation) => set((state) => {
      if (!state.answer.atmosphere || state.answer.recipes.length < 3) {
        return state
      }
      results.cocktailRecommendations.sort((a, b) => b.compatibility - a.compatibility)
      return { results, isReady: true }
    }),
    resetResults: () => set({ ...initialState, isReady: false }),
    setSecondResults: (secondResults: TRecommendation) => set((state) => {
      if (!state.answer.atmosphere || state.answer.recipes.length < 3) {
        return state
      }
      secondResults.cocktailRecommendations.sort((a, b) => b.compatibility - a.compatibility)
      return { ...state, secondResults, isReady: true }
    }),
    resetSecondResults: () => set({ ...initialState, isReady: false }),
    setAlcohol: (alcohol?: boolean) => set({ alcohol, isReady: true }),
  }), {
    name: 'answer-storage',
    storage: createJSONStorage(() => localStorage),
  }
  ))
export const useTopLabel = () => {
  const { localeData, storeConfig: { storeStyleName } } = useCmsStore()!;
  switch (storeStyleName) {
    case styleName.Master:
      return {
        storeStyleName: styleName.Master,
        content: localeData.topLabelMaster || `What's your cocktail`
      }
    case styleName.SmirnoffKenya:
      return {
        storeStyleName: styleName.SmirnoffKenya,
        content: localeData.alterTopLabelWhatsYourCocktail || `What's your Smirnoff Kenya `
      }
    case styleName.Tanqueray:
      return {
        storeStyleName: styleName.Tanqueray,
        content: localeData.backCTAName || `Back`
      }
  }
  return {
    storeStyleName: styleName.Master,
    content: localeData.topLabelMaster || `What's your cocktail`
  }
}
export const useDevice = () => {
  const [device, setDevice] = useState({
    isDesktop: false,
    isMobile: false,
  });
  function setDeviceType() {
    setDevice({
      isDesktop: window.innerWidth >= 1024,
      isMobile: window.innerWidth < 1024,
    })
  }
  useEffect(() => {
    setDeviceType()
    window.addEventListener('resize',setDeviceType)
    return () => {
      window.removeEventListener('resize',setDeviceType)
    }
  }, []);

  return device
}
export const useFlavours = () => {
  const { localeData } = useCmsStore()!;
  return localeData.flavours[0].flavours
}